export const getMembersPayload = {
    includeCommunity: false,
    filter: [{ type: "module", filter_type: "include", mod_ids: [2, 36, 4, 22] }],
  };